<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Versandoption erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.suppliers.delivery-options.store', supplier))">
                <form-fields :form="form" :supplier="supplier" :tax-calc-mode-options="taxCalcModeOptions" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'supplier',
            'taxCalcModeOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    description: null,
                    delivery_time: null,
                    tax_calc_mode: 'auto',
                    tax_rate: null,
                    free_delivery_for_all_cart_items: null,
                    sort_order: null,
                    enabled: true,
                    options: [
                        {
                            lower_bound: 0,
                            upper_bound: null,
                            amount: null,
                        }
                    ],
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>